import lodash from 'lodash';

export default {
  methods: {
    graphqlHeadersToObject(headers) {
      if (!lodash.isNil(headers)) {
        return Array.from(Object.entries(headers)).reduce((acc, [key, value]) => {
          acc[key] = value;
          return acc;
        }, {});
      }

      return {};
    },
    graphqlRequestMiddleware(request) {
      this.logToFlutter({
        level: 'D',
        message: `--> SPA GraphQL request ${request.method.toUpperCase()}`
      });
      this.logToFlutter({
        level: 'D',
        message: `Headers ${JSON.stringify(this.graphqlHeadersToObject(request.headers))}`
      });
      this.logToFlutter({
        level: 'D',
        message: `Body ${request.body}`
      });
      this.logToFlutter({
        level: 'D',
        message: '--> End GraphQL request'
      });

      request.headers.set('Authorization', `Bearer ${this.$auth.token}`);
      return request;
    },
    graphqlResponseMiddleware(response) {
      if (!response) {
        return;
      }
      this.logToFlutter({
        level: 'D',
        message: '--> SPA GraphQL response'
      });
      this.logToFlutter({
        level: 'D',
        message: `Headers ${JSON.stringify(this.graphqlHeadersToObject(response.headers))}`
      });
      this.logToFlutter({
        level: 'D',
        message: `Response ${JSON.stringify(response.status)} ${JSON.stringify(response.data)}`
      });
      this.logToFlutter({
        level: 'D',
        message: '--> End GraphQL response'
      });
    }
  }
};
